export default  {
  "version": "3.0.2",
  "900130": {
    "ENG": "Use this Rule if Drupal and WordPress Exclusion could be enabled",
    "KOR": "Drupal 및 WordPress 제외를 사용할 수 있는 경우 사용"
  },
  "900300": {
    "ENG": "Set the Max Number of Arguments (255)",
    "KOR": "최대 인수 수 설정 (기본값: 255)"
  },
  "900310": {
    "ENG": "Set the Max Length of Any Argument Name (100)",
    "KOR": "인수 이름의 최대 길이 설정 (기본값: 100)"
  },
  "900320": {
    "ENG": "Set the Max Length of Any Argument Value (400)",
    "KOR": "모든 인수 값의 최대 길이 설정 (기본값: 400)"
  },
  "900330": {
    "ENG": "Set the Max Length of All Combined Arguments (64000)",
    "KOR": "결합 된 모든 인수의 최대 길이 설정 (기본값: 64000)"
  },
  "901001": {
    "ENG": "Checks if crs-setup.conf was loaded",
    "KOR": "crs-setup.conf가 업로드 되었는지 확인"
  },
  "901100": {
    "ENG": "Default Inbound Anomaly Threshold Level Setup",
    "KOR": "기본 인바운드 이상 임계값 수준 설정"
  },
  "901110": {
    "ENG": "Default Outbound Anomaly Threshold Level Setup",
    "KOR": "기본 아웃 바운드 이상 임계값 수준 설정"
  },
  "901120": {
    "ENG": "Default Paranoia Level Setup",
    "KOR": "기본 보안 정책 레벨 설정"
  },
  "901130": {
    "ENG": "Default Sampling Percentage Setup",
    "KOR": "기본 샘플링 백분율 설정"
  },
  "901140": {
    "ENG": "Default Anomaly Scores Setup",
    "KOR": "기본 이상 점수 설정"
  },
  "901141": {
    "ENG": "Default Error Anomaly Scores Setup",
    "KOR": "기본 오류 이상 점수 설정"
  },
  "901142": {
    "ENG": "Default Warning Anomaly Scores Setup",
    "KOR": "기본 경고 이상 점수 설정"
  },
  "901143": {
    "ENG": "Default Notice Anomaly Scores Setup",
    "KOR": "기본 공지 이상 점수 설정"
  },
  "901150": {
    "ENG": "Default Do_Reput_Block Setup",
    "KOR": "기본 Do_Reput_차단 설정"
  },
  "901152": {
    "ENG": "Default Block Duration Setup",
    "KOR": "기본 차단 기간 설정"
  },
  "901160": {
    "ENG": "Default HTTP Policy : allowed_methods",
    "KOR": "기본 HTTP 정책 : allowed_methods"
  },
  "901162": {
    "ENG": "Default HTTP Policy : allowed_request_content_type",
    "KOR": "기본 HTTP 정책 : allowed_request_content_type"
  },
  "901163": {
    "ENG": "Default HTTP Policy : allowed_http_versions",
    "KOR": "기본 HTTP 정책 : allowed_http_versions"
  },
  "901164": {
    "ENG": "Default HTTP Policy : restricted_extensions",
    "KOR": "기본 HTTP 정책 : restricted_extensions"
  },
  "901165": {
    "ENG": "Default HTTP Policy : restricted_headers",
    "KOR": "기본 HTTP 정책 : restricted_headers"
  },
  "901166": {
    "ENG": "Default HTTP Policy: static_extensions",
    "KOR": "기본 HTTP 정책 : static_extensions"
  },
  "901200": {
    "ENG": "Initialize Anomaly Scoring Variables",
    "KOR": "이상 스코어 변수 초기화"
  },
  "901318": {
    "ENG": "Initialize Collections : User-Agent Hash",
    "KOR": "컬렉션 초기화 : User-Agent Hash"
  },
  "901321": {
    "ENG": "Initialize Collections : Global and IP",
    "KOR": "컬렉션 초기화 : Global and IP"
  },
  "901400": {
    "ENG": "Checks The Sampling Percentage",
    "KOR": "샘플링의 백분율 확인"
  },
  "901410": {
    "ENG": "Checks The UNIQUE_ID",
    "KOR": "UNIQUE_ID를 확인"
  },
  "901420": {
    "ENG": "Checks The DURATION Count",
    "KOR": "DURATION 수를 확인"
  },
  "901430": {
    "ENG": "Checks The Pseudo Random Number",
    "KOR": "허위의 난수 확인"
  },
  "901440": {
    "ENG": "Checks The Pseudo Random Number",
    "KOR": "허위의 난수 확인"
  },
  "901450": {
    "ENG": "Sampling Decision : Disable the rule engine based on sampling percentage",
    "KOR": "Sampling Decision : 샘플링 비율에 따라 규칙 엔진 사용 안함"
  },
  "9001000": {
    "ENG": "Checks The crs_exclusion_drupal (check if rule 900130 is enabled)",
    "KOR": "crs_exclusion_drupal의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9001100": {
    "ENG": "Drupal Rule Exclusion for Session Cookie : 942450 SQL Hex Encoding Identified",
    "KOR": "세션 쿠키에 대한 Drupal 규칙 제외: 942450 룰셋"
},
"9001110": {
    "ENG": "Drupal Rule Exclusion for Password",
    "KOR": "암호에 대한 Drupal 규칙 제외"
},
"9001112": {
    "ENG": "Drupal Rule Exclusion for Password",
    "KOR": "암호에 대한 Drupal 규칙 제외"
},
"9001114": {
    "ENG": "Drupal Rule Exclusion for Password",
    "KOR": "암호에 대한 Drupal 규칙 제외"
},
"9001116": {
    "ENG": "Drupal Rule Exclusion for Password",
    "KOR": "암호에 대한 Drupal 규칙 제외"
},
"9001122": {
    "ENG": "Drupal Rule Exclusion for Admin Settings",
    "KOR": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001124": {
    "ENG": "Drupal Rule Exclusion for Admin Settings",
    "KOR": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001126": {
    "ENG": "Drupal Rule Exclusion for Admin Settings",
    "KOR": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001128": {
    "ENG": "Drupal Rule Exclusion for Admin Settings",
    "KOR": "관리자 설정에 대한 Drupal 규칙 제외"
},
"9001140": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001160": {
    "ENG": "Drupal Rule Exclusion for for form_build_id ,form_token and form_build_id",
    "KOR": "for, form_build_id ,form_token and form_build_id에 대한 Drupal 규칙 제외"
},
"9001170": {
    "ENG": "Drupal Rule Exclusion for Text Formats and Editors",
    "KOR": "텍스트 형식 및 편집기에 대한 Drupal 규칙 제외"
},
"9001180": {
    "ENG": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KOR": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001182": {
    "ENG": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KOR": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001184": {
    "ENG": "Drupal Rule Exclusion for WYSIWYG/CKEditor Assets and Upload",
    "KOR": "WYSIWYG/CKEditor 애셋 및 업로드에 대한 Drupal 규칙 제외"
},
"9001200": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001202": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001204": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001206": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001208": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001210": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001212": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001214": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9001216": {
    "ENG": "Drupal Rule Exclusion for Content and Descriptions",
    "KOR": "콘텐츠 및 설명에 대한 Drupal 규칙 제외"
},
"9002000": {
    "ENG": "Checks The crs_exclusions_wordpress for phase 1 (check if rule 900130 is enabled)",
    "KOR": "페이즈 1에서 crs_exclusions_wordpress의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9002001": {
    "ENG": "Checks The crs_exclusions_wordpress for phase 2 (check if rule 900130 is enabled)",
    "KOR": "페이즈 2에서 crs_exclusions_wordpress의 규칙 확인(규칙 900130이 사용 가능한지 확인)"
},
"9002100": {
    "ENG": "WordPress Rule Exclusion for Login form : User login password",
    "KOR": "로그인 양식에 대한 WordPress 규칙 제외 : 사용자 로그인 비밀번호"
},
"9002120": {
    "ENG": "WordPress Rule Exclusion for Login form : Reset password",
    "KOR": "로그인 양식에 대한 WordPress 규칙 제외 : 비밀번호 재설정"
},
"9002130": {
    "ENG": "WordPress Rule Exclusion for Live preview : Post comment",
    "KOR": "실시간 미리보기에 대한 WordPress 규칙 제외 : 댓글 게시"
},
"9002150": {
    "ENG": "WordPress Rule Exclusion for Live preview : Theme select",
    "KOR": "실시간 미리보기에 대한 WordPress 규칙 제외 : 테마 선택"
},
"9002160": {
    "ENG": "WordPress Rule Exclusion for Live preview : Appearance -> Widgets -> Live Preview",
    "KOR": "실시간 미리보기에 대한 WordPress 규칙 제외 : 모양-> 위젯-> 실시간 미리보기"
},
"9002200": {
    "ENG": "WordPress Rule Exclusion for Live preview : Self calls to wp-cron.php?doing_wp_cron=[timestamp]",
    "KOR": "실시간 미리보기에 대한 WordPress 규칙 제외: wp-cron.doing_wp_cron=[timestamp]에 대한 자체 호출"
},
"9002300": {
    "ENG": "WordPress Rule Exclusion for Cookies : WP Session Manager",
    "KOR": "쿠키에 대한 WordPress 규칙 제외 : WP 세션 관리자"
},
"9002400": {
    "ENG": "WordPress Rule Exclusion for WordPress Administration Back-End (wp-admin)",
    "KOR": "WordPress 관리 백엔드에 대한 WordPress 규칙 제외(wp-admin)"
},
"9002401": {
    "ENG": "WordPress Rule Exclusion for WordPress Administration Back-End (wp-admin)",
    "KOR": "WordPress 관리 백엔드에 대한 WordPress 규칙 제외(wp-admin)"
},
"9002410": {
    "ENG": "WordPress Rule Exclusion for WordPress Installation : exclude database password",
    "KOR": "WordPress 설치를 위한 WordPress 규칙 제외: 데이터베이스 암호 제외"
},
"9002420": {
    "ENG": "WordPress Rule Exclusion for WordPress Installation : exclude admin password",
    "KOR": "WordPress 설치를 위한 WordPress 규칙 제외: admin 암호 제외"
},
"9002520": {
    "ENG": "WordPress Rule Exclusion for User Management : Edit logged-in user",
    "KOR": "User Management를 위한 WordPress 규칙 제외: logged-in user 수정"
},
"9002530": {
    "ENG": "WordPress Rule Exclusion for User Management : Edit user",
    "KOR": "User Management를 위한 WordPress 규칙 제외: user 수정"
},
"9002540": {
    "ENG": "WordPress Rule Exclusion for User Management : Create user",
    "KOR": "User Management를 위한 WordPress 규칙 제외: user 생성"
},
"9002600": {
    "ENG": "WordPress General Exclusions",
    "KOR": "WordPress 일반 제외"
},
"9002700": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Edit posts and pages",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 게시물 및 페이지 수정"
},
"9002710": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Autosave posts and pages",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 게시물 및 페이지 자동저장"
},
"9002720": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Edit menus",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 매뉴 수정"
},
"9002730": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Edit text widgets",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 텍스트 위젯 수정"
},
"9002740": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Reorder widgets",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 위젯 재정렬"
},
"9002750": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Create permalink sample for new post",
    "KOR": "내용 편집을 위한 WordPress 규칙 제외: 새 게시물에 대한 영구 링크 샘플 생성"
},
"9002760": {
    "ENG": "WordPress Rule Exclusion for Content Editing : Add external link to menu",
    "KOR": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 메뉴에 외부 링크 추가"
},
"9002800": {
    "ENG": "WordPress Rule Exclusion for Options and Settings : Change site URL",
    "KOR": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 사이트 URL 변경"
},
"9002810": {
    "ENG": "WordPress Rule Exclusion for Options and Settings : Permalink settings",
    "KOR": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 영구 링크 설정"
},
"9002820": {
    "ENG": "WordPress Rule Exclusion for Options and Settings : blacklist and moderation list",
    "KOR": "콘텐츠 편집을 위한 WordPress 규칙 제외 : 블랙리스트 및 중재 목록"
},
"9002900": {
    "ENG": "WordPress Rule Exclusion for Helpers",
    "KOR": "도우미를 위한 WordPress 규칙 제외"
},
"905100": {
    "ENG": "Exception for Apache SSL pinger",
    "KOR": "Apache SSL pinger에 대한 예외"
  },
  "905110": {
    "ENG": "Exception for Apache internal dummy connection",
    "KOR": "Apache 내부 더미 연결에 대한 예외"
},
"910100" : {
  "ENG": "Client IP is from a HIGH Risk Country Location",
  "KOR": "클라이언트의 IP가 경계 지역 IP 로 접근"
},
"910000": {
    "ENG": "Request from Known Malicious Client",
    "KOR": "알려진 악성 클라이언트의 요청"
  },
  "910120": {
    "ENG": "Checks The Real-Time Block List to Skip",
    "KOR": "스킵된 실시간 차단 목록 확인"
  },
  "910130": {
    "ENG": "Skip HttpBL Checks if user has not defined one of the TX:block_* variables",
    "KOR": "사용자가 TX:block_* 변수 중 하나를 정의하지 않은 경우 HttpBL 체크를 스킵"
  },
  "910140": {
    "ENG": "Prevent Operator Error: RBL httpBl called but no key defined: set SecHttpBlKey",
    "KOR": "연산자 오류 방지: RBL httpBl이 호출되었지만 정의된 키가 없음: SecHttpBlKey 설정"
  },
  "910150": {
    "ENG": "HTTP Blacklist match for search engine IP",
    "KOR": "검색 엔진 IP에 대한 HTTP 블랙리스트 일치"
  },
  "910160": {
    "ENG": "HTTP Blacklist match for spammer IP",
    "KOR": "spammer IP에 대한 HTTP 블랙리스트 일치"
  },
  "910170": {
    "ENG": "HTTP Blacklist match for suspicious IP",
    "KOR": "의심스러운 IP에 대한 HTTP 블랙리스트 일치"
  },
  "910180": {
    "ENG": "HTTP Blacklist match for harvester IP",
    "KOR": "harvester IP에 대한 HTTP 블랙리스트 일치"
  },
  "910190": {
    "ENG": "Set The Real-Time Block List Check",
    "KOR": "실시간 차단 목록 확인 설정"
  },
  "911100": {
    "ENG": "Not Allowed Request Methods",
    "KOR": "정책에서 허용하지 않는 메서드"
},
"912100": {
    "ENG": "Skip if variables defining DoS Protection are not set for phase 1",
    "KOR": "DoS 보호를 정의하는 변수가 1 단계에 대해 설정되지 않은 경우 건너 뛰기"
  },
  "912110": {
    "ENG": "Skip if variables defining DoS Protection are not set for phase 5",
    "KOR": "DoS 보호를 정의하는 변수가 5 단계에 대해 설정되지 않은 경우 건너 뛰기"
  },
  "912120": {
    "ENG": "DoS Block and Track of requests and log",
    "KOR": "DoS 차단 및 요청 및 로그 추적"
  },
  "912130": {
    "ENG": "DoS Block and Track of requests but don't log",
    "KOR": "DoS 차단 및 요청하나 로그 기록을 하지 않음"
  },
  "912140": {
    "ENG": "Anti-Automation / DoS Protection : Skip if we have blocked the request",
    "KOR": "Anti-Automation / DoS Protection: 요청을 차단한 경우 스킵합니다."
  },
  "912150": {
    "ENG": "DOS Counter: Count the number of requests to non-static resources",
    "KOR": "DOS 카운터: 비정적 리소스에 대한 요청 수 카운트"
  },
  "912160": {
    "ENG": "Checks DOS Counter : raise from 0 to 1",
    "KOR": "DOS 카운터 확인 : 0에서 1로 올림"
  },
  "912161": {
    "ENG": "Checks DOS Counter : raise from 1 to 2",
    "KOR": "DOS 카운터 확인 : 1에서 2로 올림"
  },
  "912170": {
    "ENG": "Potential DoS Attack if The DOS_BURST_COUNTER is greater than 2",
    "KOR": "DOS_BUST_CANTER가 2보다 클 경우 잠재적인 DoS 공격으로 인지"
  },
  "912171": {
    "ENG": "Potential DoS Attack if The DOS_BURST_COUNTER is greater than 1",
    "KOR": "DOS_BUST_CANTER가 1보다 클 경우 잠재적인 DoS 공격으로 인지"
},
"913100": {
    "ENG": "Found User-Agent associated with security scanner",
    "KOR": "보안 스캐너와 연결된 사용자-에이전트 발견"
  },
  "913110": {
    "ENG": "Found Request Header associated with security scanner",
    "KOR": "보안 스캐너와 연결된 요청 헤더 발견"
  },
  "913120": {
    "ENG": "Found Request filename/argument associated with security scanner",
    "KOR": "보안 스캐너와 연결된 요청 파일 이름/인수 발견"
  },
  "913101": {
    "ENG": "Found User-Agent associated with scripting/generic HTTP client",
    "KOR": "스크립팅/일반 HTTP 클라이언트와 연결된 사용자-에이전트 발견"
  },
  "913102": {
    "ENG": "Found User-Agent associated with web crawler/bot",
    "KOR": "웹 크롤러/봇과 연결된 사용자-에이전트 발견"
},
"920100": {
    "ENG": "Invalid HTTP Request Line",
    "KOR": "잘못된 HTTP 요청 라인"
  },
  "920120": {
    "ENG": "Attempted multipart/form-data bypass",
    "KOR": "다중 파트/폼 데이터 바이패스 시도"
  },
  "920130": {
    "ENG": "Failed to parse request body.",
    "KOR": "요청 본문을 구문 분석하지 못했습니다."
  },
  "920140": {
    "ENG": "Multipart request body failed strict validation",
    "KOR": "Multipart 요청 본문에서 엄격한 유효성 검사에 실패 했습니다."
  },
  "920160": {
    "ENG": "Content-Length HTTP header is not numeric.",
    "KOR": "콘텐츠-길이 HTTP 헤더가 숫자가 아닙니다."
  },
  "920170": {
    "ENG": "GET or HEAD Request with Body Content.",
    "KOR": "본문 콘텐츠를 통한 GET 또는 HEAD 요청."
  },
  "920180": {
    "ENG": "POST request missing Content-Length Header.",
    "KOR": "POST 요청에 콘텐츠-길이 헤더가 없습니다."
  },
  "920190": {
    "ENG": "Range = Invalid Last Byte Value.",
    "KOR": "범위 = 마지막 바이트 값이 잘못되었습니다."
  },
  "920210": {
    "ENG": "Multiple/Conflicting Connection Header Data Found.",
    "KOR": "여러 개의 충돌하는 연결 헤더 데이터가 발견되었습니다."
  },
  "920220": {
    "ENG": "URL Encoding Abuse Attack Attempt",
    "KOR": "URL Encoding 남용 공격 시도"
  },
  "920240": {
    "ENG": "URL Encoding Abuse Attack Attempt",
    "KOR": "URL Encoding 남용 공격 시도"
  },
  "920250": {
    "ENG": "UTF8 Encoding Abuse Attack Attempt",
    "KOR": "UTF8 Encoding 남용 공격 시도"
  },
  "920260": {
    "ENG": "Unicode Full/Half Width Abuse Attack Attempt",
    "KOR": "유니코드 전자/반자 남용 공격 시도"
  },
  "920270": {
    "ENG": "Invalid Character in request (null character)",
    "KOR": "요청에 잘못된 문자(null 문자)"
  },
  "920280": {
    "ENG": "Request Missing a Host Header",
    "KOR": "호스트 헤더가 누락된 요청"
  },
  "920290": {
    "ENG": "Empty Host Header",
    "KOR": "빈 호스트 헤더"
  },
  "920310": {
    "ENG": "Request Has an Empty Accept Header",
    "KOR": "요청에 빈 Accept 헤더가 있음"
  },
  "920311": {
    "ENG": "Request Has an Empty Accept Header",
    "KOR": "요청에 빈 Accept 헤더가 있음"
  },
  "920330": {
    "ENG": "Empty User Agent Header",
    "KOR": "빈 사용자 에이전트 헤더"
  },
  "920340": {
    "ENG": "Request Containing Content but Missing Content-Type header",
    "KOR": "요청에 콘텐츠는 있지만 Content-Type 헤더 누락"
  },
  "920350": {
    "ENG": "Host Header is a numeric IP address",
    "KOR": "호스트 헤더가 숫자 IP 주소"
  },
  "920380": {
    "ENG": "Too Many Arguments in request",
    "KOR": "요청에 인수가 너무 많음"
  },
  "920360": {
    "ENG": "Argument Name too long",
    "KOR": "인수 이름이 너무 김"
  },
  "920370": {
    "ENG": "Argument Value too long",
    "KOR": "인수 값이 너무 김"
  },
  "920390": {
    "ENG": "Total Arguments Size exceeded",
    "KOR": "총 인수 크기 초과"
  },
  "920400": {
    "ENG": "Uploaded File Size too large",
    "KOR": "업로드된 파일 크기가 너무 큼"
  },
  "920410": {
    "ENG": "Total Uploaded Files Size too large",
    "KOR": "업로드된 총 파일 크기가 너무 큼"
  },
  "920420": {
    "ENG": "Request Content Type Not Allowed by policy",
    "KOR": "요청 콘텐츠 유형이 정책에서 허용되지 않음"
  },
  "920430": {
    "ENG": "HTTP Protocol Version Not Allowed by policy",
    "KOR": "HTTP 프로토콜 버전이 정책에서 허용되지 않음"
  },
  "920440": {
    "ENG": "URL File Extension Restricted by policy",
    "KOR": "URL 파일 확장명이 정책에서 허용되지 않음"
  },
  "920450": {
    "ENG": "HTTP header Restricted by policy (%@{MATCHED_VAR})",
    "KOR": "HTTP 헤더가 정책에서 제한됨(%@{MATCHED_VAR})"
  },
  "920200": {
    "ENG": "Range = Too many fields (6 or more)",
    "KOR": "범위 = 필드가 너무 많음(6개 이상)"
  },
  "920201": {
    "ENG": "Range = Too many fields for pdf request (35 or more)",
    "KOR": "범위 = pdf 요청에 대한 필드가 너무 많음(35개 이상)"
  },
  "920230": {
    "ENG": "Multiple URL Encoding Detected",
    "KOR": "여러 URL Encoding이 감지됨"
  },
  "920300": {
    "ENG": "Request Missing an Accept Header",
    "KOR": "Accept 헤더가 누락된 요청"
  },
  "920271": {
    "ENG": "Invalid Character in request (non printable characters)",
    "KOR": "요청에 잘못된 문자(인쇄할 수 없는 문자)"
  },
  "920320": {
    "ENG": "Missing User Agent Header",
    "KOR": "사용자 에이전트 헤더 누락"
  },
  "920121": {
    "ENG": "Attempted multipart/form-data bypass",
    "KOR": "다중 파트/폼 데이터 바이패스 시도"
  },
  "920272": {
    "ENG": "Invalid Character in request",
    "KOR": "요청에 잘못된 문자(ascii 127 미만의 인쇄 가능한 문자 이외의)"
  },
  "920202": {
    "ENG": "Range = Too many fields for pdf request (6 or more)",
    "KOR": "범위 = pdf 요청에 대한 필드가 너무 많음(6개 이상)"
  },
  "920273": {
    "ENG": "Invalid Character in request (outside of very strict set)",
    "KOR": "요청에 잘못된 문자(매우 엄격한 집합 이외의)"
  },
  "920274": {
    "ENG": "Invalid Character in request headers (outside of very strict set)",
    "KOR": "요청 헤더에 잘못된 문자(매우 엄격한 집합 이외의)"
  },
  "920460": {
    "ENG": "Abnormal Escape Characters Detected",
    "KOR": "비정상 이스케이프 문자"
},
"921100": {
    "ENG": "HTTP Request Smuggling Attack",
    "KOR": "HTTP 요청 밀반입 공격"
  },
  "921110": {
    "ENG": "HTTP Request Smuggling Attack",
    "KOR": "HTTP 요청 밀반입 공격"
  },
  "921120": {
    "ENG": "HTTP Response Splitting Attack",
    "KOR": "HTTP 응답 분할 공격"
  },
  "921130": {
    "ENG": "HTTP Response Splitting Attack",
    "KOR": "HTTP 응답 분할 공격"
  },
  "921140": {
    "ENG": "HTTP Header Injection Attack via headers",
    "KOR": "헤더를 통한 HTTP 헤더 삽입 공격"
  },
  "921150": {
    "ENG": "HTTP Header Injection Attack via payload (CR/LF detected)",
    "KOR": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 발견)"
  },
  "921160": {
    "ENG": "HTTP Header Injection Attack via payload",
    "KOR": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 및 헤더-이름 발견)"
  },
  "921151": {
    "ENG": "HTTP Header Injection Attack via payload (CR/LF detected)",
    "KOR": "페이로드를 통한 HTTP 헤더 삽입 공격(CR/LF 발견)"
  },
  "921170": {
    "ENG": "HTTP Parameter Pollution",
    "KOR": "HTTP 매개 변수 오염"
  },
  "921180": {
    "ENG": "HTTP Parameter Pollution",
    "KOR": "HTTP 매개 변수 오염 (% {TX. 1})"
},
"930100": {
    "ENG": "Path Traversal Attack (/../)",
    "KOR": "경로 탐색 공격(/../)"
  },
  "930110": {
    "ENG": "Path Traversal Attack (/../)",
    "KOR": "경로 탐색 공격(/../)"
  },
  "930120": {
    "ENG": "OS File Access Attempt",
    "KOR": "OS 파일 액세스 시도"
  },
  "930130": {
    "ENG": "Restricted File Access Attempt",
    "KOR": "제한된 파일 액세스 시도"
},
"931100": {
    "ENG": "Possible Remote File Inclusion Attack = URL Parameter using IP Address",
    "KOR": "가능한 원격 파일 포함(RFI) 공격 = IP 주소를 사용하는 URL 매개 변수"
  },
  "931110": {
    "ENG": "Possible Remote File Inclusion Attack = Common RFI Vulnerable Parameter Name used w/URL Payload",
    "KOR": "가능한 원격 파일 포함(RFI) 공격 = 일반 RFI 취약한 매개 변수 이름이 URL 페이로드에 사용됨"
  },
  "931120": {
    "ENG": "Possible Remote File Inclusion Attack = URL Payload Used w/Trailing Question Mark Character (?)",
    "KOR": "가능한 원격 파일 포함(RFI) 공격 = URL 페이로드가 후행 물음표 문자(?)에 사용됨"
  },
  "931130": {
    "ENG": "Possible Remote File Inclusion Attack = Off-Domain Reference/Link",
    "KOR": "가능한 원격 파일 포함(RFI) 공격 = 오프-도메인 참조/링크"
},
"932100": {
    "ENG": "Remote Command Execution: Unix Command Injection",
    "KOR": "원격 명령 실행: Unix 명령 삽입"
  },
  "932105": {
    "ENG": "Remote Command Execution: Unix Command Injection",
    "KOR": "원격 명령 실행: Unix 명령 삽입"
  },
  "932110": {
    "ENG": "Remote Command Execution: Windows Command Injection",
    "KOR": "원격 명령 실행: Windows 명령 삽입"
  },
  "932115": {
    "ENG": "Remote Command Execution: Windows Command Injection",
    "KOR": "원격 명령 실행: Windows 명령 삽입"
  },
  "932120": {
    "ENG": "Remote Command Execution = Windows PowerShell Command Found",
    "KOR": "원격 명령 실행 = Windows PowerShell 명령 발견"
  },
  "932130": {
    "ENG": "Remote Command Execution = Unix Shell Expression Found",
    "KOR": "원격 명령 실행 = Unix 셸 식 발견"
  },
  "932140": {
    "ENG": "Remote Command Execution = Windows FOR/IF Command Found",
    "KOR": "원격 명령 실행 = Windows FOR/IF 명령 발견"
  },
  "932150": {
    "ENG": "Remote Command Execution: Direct Unix Command Execution",
    "KOR": "원격 명령 실행: Unix 명령 직접 실행"
  },
  "932160": {
    "ENG": "Remote Command Execution = Unix Shell Code Found",
    "KOR": "원격 명령 실행 = Unix 셸 코드 발견"
  },
  "932170": {
    "ENG": "Remote Command Execution = Shellshock (CVE-2014-6271)",
    "KOR": "원격 명령 실행 = Shellshock(CVE-2014-6271)"
  },
  "932171": {
    "ENG": "Remote Command Execution = Shellshock (CVE-2014-6271)",
    "KOR": "원격 명령 실행 = Shellshock(CVE-2014-6271)"
},
"933100": {
    "ENG": "PHP Injection Attack = Opening/Closing Tag Found",
    "KOR": "PHP 삽입 공격 = 여는/닫는 태그 발견"
  },
  "933110": {
    "ENG": "PHP Injection Attack = PHP Script File Upload Found",
    "KOR": "PHP 삽입 공격 = PHP 스크립트 파일 업로드 발견"
  },
  "933120": {
    "ENG": "PHP Injection Attack = Configuration Directive Found",
    "KOR": "PHP 삽입 공격 = 구성 지시문 발견"
  },
  "933130": {
    "ENG": "PHP Injection Attack = Variables Found",
    "KOR": "PHP 삽입 공격 = 변수 발견"
  },
  "933140": {
    "ENG": "PHP Injection Attack: I/O Stream Found",
    "KOR": "PHP 삽입 공격: i/o 스트림이 있습니다."
  },
  "933150": {
    "ENG": "PHP Injection Attack = High-Risk PHP Function Name Found",
    "KOR": "PHP 삽입 공격 = 고위험 PHP 함수 이름 발견"
  },
  "933160": {
    "ENG": "PHP Injection Attack = High-Risk PHP Function Call Found",
    "KOR": "PHP 삽입 공격 = 고위험 PHP 함수 호출 발견"
  },
  "933170": {
    "ENG": "PHP Injection Attack: Serialized Object Injection",
    "KOR": "PHP 삽입 공격: 직렬화 된 개체 삽입"
  },
  "933180": {
    "ENG": "PHP Injection Attack = Variable Function Call Found",
    "KOR": "PHP 삽입 공격 = 변수 함수 호출 발견"
  },
  "933151": {
    "ENG": "PHP Injection Attack: Medium-Risk PHP Function Name Found",
    "KOR": "PHP 삽입 공격: Medium-Risk PHP 함수 이름을 찾았습니다."
  },
  "933161": {
    "ENG": "PHP Injection Attack: Low-Value PHP Function Call Found",
    "KOR": "PHP 삽입 공격: Low-Value PHP 함수 호출을 찾았습니다."
  },
  "933111": {
    "ENG": "PHP Injection Attack: PHP Script File Upload Found",
    "KOR": "PHP 삽입 공격: PHP 스크립트 파일 업로드 찾음"
},
"941100": {
    "ENG": "XSS Attack Detected via libinjection",
    "KOR": "libinjection을 통한 XSS 공격 감지됨"
  },
  "941110": {
    "ENG": "XSS Filter - Category 1 = Script Tag Vector",
    "KOR": "XSS 필터 - 범주 1 = 스크립트 태그 벡터"
  },
  "941120": {
    "ENG": "XSS Filters - Category 2 = XSS Vector",
    "KOR": "XSS 필터 - 범주 2 = XSS 벡터"
  },
  "941140": {
    "ENG": "XSS Filter - Category 4 = Javascript URI Vector",
    "KOR": "XSS 필터 - 범주 4 = Javascript URI 벡터"
  },
  "941160": {
    "ENG": "NoScript XSS InjectionChecker: HTML Injection",
    "KOR": "NoScript XSS InjectionChecker: HTML 주입"
  },
  "941170": {
    "ENG": "NoScript XSS InjectionChecker: Attribute Injection",
    "KOR": "NoScript XSS InjectionChecker: 특성 주입"
  },
  "941180": {
    "ENG": "Node-Validator Blacklist Keywords",
    "KOR": "노드 검사기 블랙리스트 키워드"
  },
  "941190": {
    "ENG": "XSS using style sheets",
    "KOR": "스타일 시트를 사용 하는 XSS"
  },
  "941200": {
    "ENG": "XSS using VML frames",
    "KOR": "VML 프레임을 사용 하는 XSS"
  },
  "941210": {
    "ENG": "XSS using obfuscated Javascript",
    "KOR": "난독 처리 Javascript를 사용 하는 XSS"
  },
  "941220": {
    "ENG": "XSS using obfuscated VB Script",
    "KOR": "난독 처리 되지 않은 VB 스크립트를 사용 하는 XSS"
  },
  "941230": {
    "ENG": "XSS using 'embed' tag",
    "KOR": " Embed ' 태그를 사용 하는 XSS"
  },
  "941240": {
    "ENG": "XSS using 'import' or 'implementation' attribute",
    "KOR": " Import ' 또는 ' 구현 ' 특성을 사용 하는 XSS"
  },
  "941250": {
    "ENG": "IE XSS Filters - Attack Detected",
    "KOR": "IE XSS 필터-공격 감지 됨"
  },
  "941260": {
    "ENG": "XSS using 'meta' tag",
    "KOR": "' Meta ' 태그를 사용 하는 XSS"
  },
  "941270": {
    "ENG": "XSS using 'link' href",
    "KOR": " Link ' href를 사용 하는 XSS"
  },
  "941280": {
    "ENG": "XSS using 'base' tag",
    "KOR": " Base ' 태그를 사용 하는 XSS"
  },
  "941290": {
    "ENG": "XSS using 'applet' tag",
    "KOR": " applet ' 태그를 사용 하는 XSS"
  },
  "941300": {
    "ENG": "XSS using 'object' tag",
    "KOR": " Object ' 태그를 사용 하는 XSS"
  },
  "941310": {
    "ENG": "US-ASCII Malformed Encoding XSS Filter - Attack Detected.",
    "KOR": "US-ASCII 잘못된 형식의 Encoding XSS 필터 - 공격 감지됨."
  },
  "941350": {
    "ENG": "UTF-7 Encoding IE XSS - Attack Detected.",
    "KOR": "UTF-7 Encoding IE XSS - 공격 감지됨."
  },
  "941101": {
    "ENG": "XSS Attack Detected via libinjection",
    "KOR": "libinjection을 통한 XSS 공격 감지됨"
  },
  "941150": {
    "ENG": "XSS Filter - Category 5 = Disallowed HTML Attributes",
    "KOR": "XSS 필터 - 범주 5 = 허용되지 않는 HTML 특성"
  },
  "941320": {
    "ENG": "Possible XSS Attack Detected - HTML Tag Handler",
    "KOR": "가능한 XSS 공격 감지됨 - HTML 태그 처리기"
  },
  "941330": {
    "ENG": "IE XSS Filters - Attack Detected.",
    "KOR": "IE XSS 필터 - 공격 감지됨."
  },
  "941340": {
    "ENG": "IE XSS Filters - Attack Detected.",
    "KOR": "IE XSS 필터 - 공격 감지됨."
},
"942100": {
    "ENG": "SQL Injection Attack Detected via libinjection",
    "KOR": "libinjection을 통한 SQL 삽입 공격 감지됨"
  },
  "942140": {
    "ENG": "SQL Injection Attack = Common DB Names Detected",
    "KOR": "SQL 삽입 공격 = 일반 DB 이름 감지됨"
  },
  "942160": {
    "ENG": "Detects blind sqli tests using sleep() or benchmark().",
    "KOR": "sleep() 또는 benchmark()를 사용하는 블라인드 sqli 테스트 감지."
  },
  "942170": {
    "ENG": "Detects SQL benchmark and sleep Injection Attempts including conditional queries",
    "KOR": "조건부 쿼리를 포함하여 SQL benchmark 및 sleep 삽입 공격 감지"
  },
  "942190": {
    "ENG": "Detects MSSQL Code Execution and Information Gathering Attempts",
    "KOR": "MSSQL 코드 실행 및 정보 수집 시도 감지"
  },
  "942220": {
    "ENG": "Looking for integer overflow attacks",
    "KOR": "정수 오버플로 공격을 찾고 3.0.00738585072를 제외 하 고 skipfish에서 가져옵니다."
  },
  "942230": {
    "ENG": "Detects conditional SQL injection attempts",
    "KOR": "조건부 SQL 삽입 시도 감지"
  },
  "942240": {
    "ENG": "Detects MySQL charset switch and MSSQL DoS attempts",
    "KOR": "MySQL 문자 집합 스위치 및 MSSQL DoS 시도를 검색 합니다."
  },
  "942250": {
    "ENG": "Detects MATCH AGAINST, MERGE and EXECUTE IMMEDIATE injections",
    "KOR": "일치 항목을 검색 하고 병합 하고 즉시 삽입을 실행 합니다."
  },
  "942270": {
    "ENG": "Looking for Basic sql Injection. Common attack string for mysql oracle and others",
    "KOR": "기본적인 sql 삽입 검색. Mysql oracle 및 기타에 대한 일반적인 공격 문자열"
  },
  "942280": {
    "ENG": "Detects Postgres pg_sleep Injection, wait for Delay Attacks and Database Shutdown Attempts",
    "KOR": "Postgres pg_sleep 주입 waitfor 지연 공격 및 데이터베이스 종료 시도를 검색 합니다."
  },
  "942290": {
    "ENG": "Finds Basic MongoDB SQL Injection attempts",
    "KOR": "기본적인 MongoDB SQL 삽입 시도 찾기"
  },
  "942320": {
    "ENG": "Detects MySQL and PostgreSQL stored procedure/function Injections",
    "KOR": "MySQL 및 PostgreSQL에 저장된 저장 프로시저/함수 삽입 감지"
  },
  "942350": {
    "ENG": "Detects MySQL UDF Injection and other data/structure Manipulation Attempts",
    "KOR": "MySQL UDF 삽입 및 기타 데이터/구조 조작 시도 감지"
  },
  "942360": {
    "ENG": "Detects Concatenated Basic SQL Injection and SQLLFI Attempts",
    "KOR": "연결된 기본 SQL 삽입 및 SQLLFI 시도 감지"
  },
  "942110": {
    "ENG": "SQL Injection Attack: Common Injection Testing Detected",
    "KOR": "SQL 삽입 공격: 일반적인 주입 테스트가 검색 됨"
  },
  "942120": {
    "ENG": "SQL Injection Attack: SQL Operator Detected",
    "KOR": "SQL 삽입 공격: SQL 연산자가 검색 되었습니다."
  },
  "942130": {
    "ENG": "SQL Injection Attack: SQL Tautology Detected.",
    "KOR": "SQL 삽입 공격: SQL Tautology 검색 되었습니다."
  },
  "942150": {
    "ENG": "SQL Injection Attack",
    "KOR": "SQL 삽입 공격"
  },
  "942180": {
    "ENG": "Detects Basic SQL Authentication Bypass Attempts 1/3",
    "KOR": "기본 SQL 인증 바이패스 시도 감지 1/3"
  },
  "942200": {
    "ENG": "Detects MySQL Comment-/space-obfuscated Injections and Backtick Termination",
    "KOR": "MySQL 주석-/공백-난독 처리된 삽입 및 억음 악센트 기호 종료 감지"
  },
  "942260": {
    "ENG": "Detects Basic SQL Authentication Bypass Attempts 2/3",
    "KOR": "기본 SQL 인증 바이패스 시도 감지 2/3"
  },
  "942300": {
    "ENG": "Detects MySQL Comments, Conditions and ch(a)r Injections",
    "KOR": "MySQL 주석"
  },
  "942310": {
    "ENG": "Detects chained SQL Injection Attempts 2/2",
    "KOR": "연결된 SQL 삽입 시도 감지 2/2"
  },
  "942330": {
    "ENG": "Detects Classic SQL Injection Probings 1/2",
    "KOR": "클래식 SQL 삽입 프로빙 감지 1/2"
  },
  "942340": {
    "ENG": "Detects Basic SQL Authentication Bypass Attempts 3/3",
    "KOR": "기본 SQL 인증 바이패스 시도 감지 3/3"
  },
  "942370": {
    "ENG": "Detects Classic SQL Injection Probings 2/2",
    "KOR": "클래식 SQL 삽입 프로빙 감지 2/2"
  },
  "942380": {
    "ENG": "SQL Injection Attack",
    "KOR": "SQL 삽입 공격"
  },
  "942400": {
    "ENG": "SQL Injection Attack",
    "KOR": "SQL 삽입 공격"
  },
  "942410": {
    "ENG": "SQL Injection Attack",
    "KOR": "SQL 삽입 공격"
  },
  "942430": {
    "ENG": "Restricted SQL Character Anomaly Detection (args)",
    "KOR": "제한된 SQL 문자 이상 감지(인수): 특수 문자 # 초과(12)"
  },
  "942450": {
    "ENG": "SQL Hex Encoding Identified",
    "KOR": "SQL 16진수 Encoding이 식별됨"
  },
  "942251": {
    "ENG": "Detects HAVING Injections",
    "KOR": "HAVING 삽입 감지"
  },
  "942420": {
    "ENG": "Restricted SQL Character Anomaly Detection (cookies)",
    "KOR": "제한 된 SQL 문자 이상 검색 (쿠키): 특수 문자 # 개 초과 (8)"
  },
  "942460": {
    "ENG": "Meta-Character Anomaly Detection Alert - Repetitive Non-Word Characters",
    "KOR": "메타 문자 이상 감지 경고 - 반복적인 단어가 아닌 문자"
  },
  "942421": {
    "ENG": "Restricted SQL Character Anomaly Detection (cookies)",
    "KOR": "제한 된 SQL 문자 변칙 검색 (쿠키): 특수 문자 # 개 초과 (3)"
  },
  "942432": {
    "ENG": "Restricted SQL Character Anomaly Detection (args)",
    "KOR": "제한 된 SQL 문자 이상 검색 (인수): 특수 문자 # 개 초과 (2)"
},
"943100": {
    "ENG": "Possible Session Fixation Attack = Setting Cookie Values in HTML",
    "KOR": "가능한 세션 고정 공격 = HTML의 쿠키 값 설정"
  },
  "943110": {
    "ENG": "Possible Session Fixation Attack = SessionID Parameter Name with Off-Domain Referrer",
    "KOR": "가능한 세션 고정 공격 = 오프-도메인 참조 페이지가 있는 SessionID 매개 변수 이름"
  },
  "943120": {
    "ENG": "Possible Session Fixation Attack = SessionID Parameter Name with No Referrer",
    "KOR": "가능한 세션 고정 공격 = 참조 페이지가 없는 SessionID 매개 변수 이름"
},
"949100": {
    "ENG": "IP Reputation Checks",
    "KOR": "IP 평판 확인"
  },
  "949110": {
    "ENG": "Anomaly Mode: Overall Transaction Anomaly Score",
    "KOR": "이상 모드: 전체 트랜잭션 이상 점수"
},
"950130": {
    "ENG": "Directory Listing",
    "KOR": "디렉터리 목록"
  },
  "950100": {
    "ENG": "The Application Not Available - 5xx level status code",
    "KOR": "응용 프로그램을 사용할 수 없음 - 5xx 레벨의 상태 코드시"
},
"951100": {
    "ENG": "SQL Error Leakages",
    "KOR": "SQL 오류 유출"
  },
  "951110": {
    "ENG": "Microsoft Access SQL Information Leakage",
    "KOR": "Microsoft Access SQL 정보 유출"
  },
  "951120": {
    "ENG": "Oracle SQL Information Leakage",
    "KOR": "Oracle SQL 정보 유출"
  },
  "951130": {
    "ENG": "DB2 SQL Information Leakage",
    "KOR": "DB2 SQL 정보 유출"
  },
  "951140": {
    "ENG": "EMC SQL Information Leakage",
    "KOR": "EMCSQL 정보 유출"
  },
  "951150": {
    "ENG": "firebird SQL Information Leakage",
    "KOR": "firebird SQL 정보 유출"
  },
  "951160": {
    "ENG": "Frontbase SQL Information Leakage",
    "KOR": "Frontbase SQL 정보 유출"
  },
  "951170": {
    "ENG": "hsqldb SQL Information Leakage",
    "KOR": "hsqldb SQL 정보 유출"
  },
  "951180": {
    "ENG": "informix SQL Information Leakage",
    "KOR": "informix SQL 정보 유출"
  },
  "951190": {
    "ENG": "ingres SQL Information Leakage",
    "KOR": "ingres SQL 정보 유출"
  },
  "951200": {
    "ENG": "interbase SQL Information Leakage",
    "KOR": "interbase SQL 정보 유출"
  },
  "951210": {
    "ENG": "maxDB SQL Information Leakage",
    "KOR": "maxDB SQL 정보 유출"
  },
  "951220": {
    "ENG": "mssql SQL Information Leakage",
    "KOR": "mssql SQL 정보 유출"
  },
  "951230": {
    "ENG": "mysql SQL Information Leakage",
    "KOR": "mysql SQL 정보 유출"
  },
  "951240": {
    "ENG": "postgres SQL Information Leakage",
    "KOR": "postgres SQL 정보 유출"
  },
  "951250": {
    "ENG": "sqlite SQL Information Leakage",
    "KOR": "sqlite SQL 정보 유출"
  },
  "951260": {
    "ENG": "Sybase SQL Information Leakage",
    "KOR": "Sybase SQL 정보 유출"
},
"952100": {
    "ENG": "Java Source Code Leakages",
    "KOR": "자바 소스 코드 유출"
  },
  "952110": {
    "ENG": "Java Errors",
    "KOR": "자바 오류"
},
"953100": {
    "ENG": "PHP Error Message Leakage",
    "KOR": "PHP 오류 메시지 유출"
  },
  "953110": {
    "ENG": "PHP Source Code Leakage",
    "KOR": "PHP 소스 코드 유출"
  },
  "953120": {
    "ENG": "Detect The Presence of the PHP Open Tag",
    "KOR": "자바 오류 PHP 오픈 태그의 존재 감지"
},
"954100": {
    "ENG": "Disclosure of IIS install location",
    "KOR": "IIS 설치 위치 공개"
  },
  "954110": {
    "ENG": "Application Availability Error",
    "KOR": "애플리케이션 가용성 오류"
  },
  "954120": {
    "ENG": "IIS Information Leakage",
    "KOR": "IIS 정보 유출"
  },
  "954130": {
    "ENG": "IIS Information Leakage",
    "KOR": "IIS 정보 유출"
},
"959100": {
    "ENG": "Alert and Block on High Anomaly Scores",
    "KOR": "높은 이상 스코어에 대한 경고 및 차단"
},
"980100": {
    "ENG": "Correlated Successful Attack",
    "KOR": "상관 관계가있는 성공적인 공격"
  },
  "980110": {
    "ENG": "Correlated Attack Attempt",
    "KOR": "상관된 공격 시도"
  },
  "980120": {
    "ENG": "Inbound Anomaly Score Exceeded",
    "KOR": "인바운드 이상 점수 초과"
  },
  "980130": {
    "ENG": "Inbound Anomaly Score Exceeded ",
    "KOR": "인바운드 이상 점수 초과"
  },
  "980140": {
    "ENG": "Outbound Anomaly Score Exceeded",
    "KOR": "아웃바운드 이상 점수 초과"
  },
  "1000001" : {
    "ENG" : "Malicious Request URI detected by Custom Policy",
    "KOR" : "사용자 지정 정책에서 탐지된 악의적인 요청 URI"
  },
  "1000002" : {
    "KOR" : "사용자 지정 정책에 의해 차단된 악의적인 경로",
    "ENG" : "Malicious Path blocked by Custom Policy"
  },
  "1000020" : {
    "KOR" : "사용자 지정 정책에 의해 차단된 악의적인 IP",
    "ENG" : "Malicious IP blocked by Custom Policy"
  },
  "1000010" : {
    "KOR" : "IP 주소가 사용자 지정 정책에 의한 화이트리스트임",
    "ENG" : "IP Address is Whitelist by Custom Policy"
  },
  "933131" : {
    "ENG" : "PHP Injection Attack: Variables Found",
    "KOR" : "PHP 코드 삽입 공격 : PHP 문법 변수 탐지"
  },
  "941130" : {
    "ENG" : "XSS Filter - Category 3 = Attribute Vector",
    "KOR" : "XSS 필터 - 범주 3 = 속성 벡터"
  },
  "942431" : {
    "ENG" : "Restricted SQL Character Anomaly Detection (args)",
    "KOR" : "제한된 SQL 문자 이상 탐지(arg)"
  },
  "4200011"	 : {
    "ENG" : "Gnuboard Vulnerability	Block	PL1	critical",
    "KOR" : "Gnuboard 취약성 블록 PL1 중요"
  },
	"4200012"	 : {
    "ENG" : "TechNote Vulnerability	Block	PL1	critical",
    "KOR" : "TechNote 취약성 블록 PL1 중요"
  },
	"4200013"	 : {
    "ENG" : "ZeroBoard Vulnerability - except dir	Block	PL1	critical",
    "KOR" : "ZeroBoard 취약성 - dir 블록 PL1을 제외하고 중요"
  },
	"4200014"	 : {
    "ENG" : "Common Board Vulnerabilities	Block	PL1	critical",
    "KOR" : "공통 보드 취약성 블록 PL1 중요"
  },
	"4200015"	 : {
    "ENG" : "PHP Code Injection - base64_decode	Block	PL1	critical",
    "KOR" : "PHP 코드 주입 - base64_decode 블록 PL1 중요"
  },
	"4200016"	 : {
    "ENG" : "Java Code Injection - Runtime	Block	PL1	critical",
    "KOR" : "Java 코드 주입 - 런타임 블록 PL1 중요"
  },
	"4200017"	 : {
    "ENG" : "Command Injection	Block	PL1	critical",
    "KOR" : "명령 주입 블록 PL1 중요"
  },
	"4200018"	 : {
    "ENG" : "wget Command Injection	Block	PL1	critical",
    "KOR" : "wget 명령 주입 블록 PL1 중요"
  },
	"4200019"	 : {
    "ENG" : "Remote File Inclusion	Block	PL1	critical",
    "KOR" : "원격 파일 포함 블록 PL1 중요"
  },
	"4200020"	 : {
    "ENG" : "Detect phpinfo Injection	Block	PL1	critical",
    "KOR" : "phpinfo 주입 블록 PL1 검출 중요"
  },
	"4200021"	 : {
    "ENG" : "Web Shell - Code Injection - Common	Block	PL1	critical",
    "KOR" : "웹 셸 - 코드 주입 - 공통 블록 PL1 중요"
  },
	"4200022"	 : {
    "ENG" : "Detect ASP Config	Block	PL1	critical",
    "KOR" : "ASP 구성 블록 PL1 탐지 중요"
  },
	"4200023"	 : {
    "ENG" : "Access Web Setting files	Block	PL1	critical",
    "KOR" : "웹 설정 파일 액세스 PL1 차단 중요"
  },
	"4200024"	 : {
    "ENG" : "Remote Command Execution	Block	PL1	critical",
    "KOR" : "원격 명령 실행 블록 PL1 중요"
  },
	"4200025"	 : {
    "ENG" : "Vulnerabilities - ASP Sample Pages	Block	PL1	critical",
    "KOR" : "취약성 - ASP 샘플 페이지 블록 PL1 중요"
  },
	"4200026"	 : {
    "ENG" : "Vulnerabilities - CGI Sample Pages",
    "KOR" : "취약성 - CGI 샘플 페이지"
  }
}
